module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "emoji-picker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchValue),
      expression: "searchValue"
    }],
    ref: "searchInput",
    attrs: {
      "type": "text",
      "placeholder": "Search emoji"
    },
    domProps: {
      "value": (_vm.searchValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('ul', {
    ref: "emojiCategories",
    staticClass: "emoji-category-list",
    on: {
      "scroll": function($event) {
        _vm.onScroll()
      }
    }
  }, _vm._l((_vm.emojiRenderGroups), function(emojiRenderGroup) {
    return _c('li', {
      key: emojiRenderGroup.key,
      staticClass: "emoji-category"
    }, [(emojiRenderGroup.title) ? _c('div', {
      staticClass: "emoji-category-title"
    }, [_vm._v("\n                " + _vm._s(emojiRenderGroup.title) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "emoji-list"
    }, _vm._l((emojiRenderGroup.emoji), function(emoji) {
      return _c('button', {
        key: emoji.value,
        ref: "emojiLi",
        refInFor: true,
        style: (_vm.getButtonStyle(emoji)),
        attrs: {
          "data-emoji-value": emoji.value,
          "title": emoji.label
        },
        on: {
          "click": function($event) {
            _vm.pickEmoji(emoji)
          }
        }
      })
    }))])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55ce627c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/emoji-picker/index.vue
// module id = 2049
// module chunks = 2